import UAParser from 'ua-parser-js';
import { DeviceInterface as Device } from '@videoblocks/events-ts/lib/storyblocks/common/Device';

export default function parseDevice(headers: Headers, referrerUrl: string | undefined): Device {
    const language = headers.get('Accept-Language') ?? '';
    const header = headers.get('User-Agent');

    let userAgent = '',
        name = '',
        platform = '';

    if (header) {
        const uaParser = new UAParser(header);
        userAgent = uaParser.getUA();
        name = uaParser.getBrowser().name ?? '';
        platform = uaParser.getOS().name ?? '';
    }

    return {
        browser: { language, name, platform, userAgent },
        navigation: { referrerUrl: referrerUrl ?? '' }
    };
}
